import React from 'react';
import ReactDOM from 'react-dom';
import Container from './components/container';

document.addEventListener('DOMContentLoaded', e => {
  const container = document.getElementById('js-gravureImageContainer');
  if (!document.body.contains(container)) return;
  ReactDOM.render(
    <Container
      gravureData={JSON.parse(container.dataset.gravureData)}
    />,
    container
  )
});
